module.exports = __webpack_public_path__ + "static/media/water.4466e70f.svg";